import React, { ReactElement } from 'react';
import TableData from './TableDataContainer.styled';
import { ComponentProps, TableDataProps } from './TableDataContainer.types';

const TableDataContainer: React.FC<ComponentProps & TableDataProps> = ({
  children,
  ...props
}): ReactElement<ComponentProps> => <TableData {...props}>{props.value}</TableData>;

export default TableDataContainer;
